import React from "react";
import styled from "styled-components";

import BasicHeaderSection from "../../sections/BasicHeaderSection";

const StyledAboutPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 100px);

  > div:nth-child(2) {
    flex-grow: 1;
    width: 50%;

    padding-top: 60px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 40px;

    p {
      font-family: 'MerriweatherLight';
      font-size: 16px;
      line-height: 26px;
      text-align: justify;
      color: #1B3858;
    }
  }

  @media ${({ theme }) => theme.devices.laptopM} {
    > div:nth-child(2) {
      width: 60%;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    > div:nth-child(2) {
      width: 70%;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);

    > div:nth-child(2) {
      width: 100%;

      padding-top: 40px;
      padding-bottom: 20px;

      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
`;

function AboutPage() {
  return (
    <StyledAboutPage>
      <BasicHeaderSection
        title="Get to Know Us"
      />
      <div>
        <p>
          We are not the government we are a 3rd party company here to help
          people with the application process. We come from a background of
          business experts who wanted to be able to help other people start
          their businesses. And we know the first step to starting your business
          is to become a legitimate business in the eyes of the government.
        </p>
        <p>
          We started the service to make the process of beginning your journey
          into the entrepreneurial world a little easier. With all of the
          options and possibilities to make a mistake and deter you from
          starting your business before you’ve even helped your first customer,
          we wanted to make sure that doesn’t happen.
        </p>
        <p>
          Many of the people who work here have a background in business
          consulting in this business was started because we saw a need with
          helping new businesses to get established properly and then set up for
          success and profitability.
        </p>
      </div>
    </StyledAboutPage>
  );
}

export default AboutPage;
